// Copyright (c) 2019 Deere & Company

import OktaState from '../state/okta-state';
import actions from '../../../sharedmodules/actions-list';
import { getDefaultState } from '../state/index';

const updateIsAuthenticated = (state, action) => OktaState.update(state, {
    isAuthenticated: {
        $set: action.isAuthenticated,
    },
});

const updateUserName = (state, action) => OktaState.update(state, {
    userName: {
        $set: action.userName,
    },
});

const updateUserId = (state, action) => OktaState.update(state, {
    userId: {
        $set: action.userId,
    },
});

export default (state = getDefaultState().oktaState, action) => {

    const actionTypes = {
        [actions.UPDATE_OKTA_STATE_IS_AUTHENTICATED]: updateIsAuthenticated,
        [actions.UPDATE_OKTA_STATE_USER_NAME]: updateUserName,
        [actions.UPDATE_OKTA_STATE_USER_ID]: updateUserId,
    };

    const reducer = actionTypes[action.type];

    return reducer
        ? reducer(state, action)
        : state;

};
